export const categories = {
    ESSENTIAL: 'essential',
    ANALYTICAL: 'analytical',
    MARKETING: 'marketing',
};
